// 客户费率模板

import { HttpInboundBillClientList, HttpSubmitInboundBill,HttpRemarkInboundBill, HttpCancelInboundBill, HttpExportInboundBill,HttpReprocessError,HttpIgnoreInboundError, HttpGetInbopundMangeSpan, HttpGetAreaList } from '@/service/inbound';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import mixin from '../mixin';
import comIndex from '../billclient/update'
import modifyDate from '../billclient/modifydate'
import comWarehouse from './changeWarehouse'

import compDelivergood from '../billclient/delivergood';
import compAppointorder from '../billclient/appointorder';

export default {
    mixins: [TableList, mixin],
    components:{
        comIndex,
        comWarehouse,
        compDelivergood,
        compAppointorder,
        modifyDate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                isManage: true,
                search: {
                    'quanbu': 0,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            cusWareList:[],
            channelList:[],
            areaList: [],
            spanTabs: { show: true },
        };
    },
    created() {
        // 添加权限
		this.perUpdate = this.handleAuth('fbb.inboundplan.update');
        this.getAreaList();
    },
    methods: {
        async getAreaList () {
            await HttpGetAreaList().then(res => {
                this.areaList = res.data.map(item => {
                    return {
                        label: item.areaName,
                        value: item.id
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        ajaxRequest: HttpInboundBillClientList,
        spanAjaxRequest: HttpGetInbopundMangeSpan,
        handleParams(params) {
            // console.log(params);

            if (params.search.quanbu === 0) {
                params.search.EQ_inboundPlanOrderStatus = null;
            }
            else if (params.search.shenhe === 0) {
                params.search.EQ_inboundPlanOrderStatus = 5
            }
            else if (params.search.juhui === 0) {
                params.search.EQ_inboundPlanOrderStatus = 6
            }
            else if (params.search.unpacked === 0) {
                params.search.EQ_inboundPlanOrderStatus = 8
            }
            else if (params.search.unship === 0) {
                params.search.EQ_inboundPlanOrderStatus = 10;
            }
            else if (params.search.shipped === 0) {
                params.search.EQ_inboundPlanOrderStatus = 20;
            }
            else if (params.search.inthe_library === 0) {
                params.search.EQ_inboundPlanOrderStatus = 25;
            }else if (params.search.finished === 0) {
                params.search.EQ_inboundPlanOrderStatus = 70;
            }else if (params.search.error_order === 0) {
                params.search.NE_errorStatus = 99999;
            }

            delete params.search.quanbu
            delete params.search.shenhe
            delete params.search.juhui
            delete params.search.unpacked
            delete params.search.unship
            delete params.search.shipped
            delete params.search.inthe_library
            delete params.search.finished
            delete params.search.error_order

            return params
        },
        interceptRequest(params) {
            const { warehouseId,CN_cartonNo,sku,CN_inboundPlanOrderNo } = params.search;

            let IN_inboundPlanOrderNo,cartonNo,arr1,arr2=[],arr3,arr4=[];
            if(CN_inboundPlanOrderNo){
                arr1 = CN_inboundPlanOrderNo.split(/\n/);
                arr1.map(item=>{
                    if(item){
                        arr2.push(item)
                    }
                })
                if(arr2.length>0){
                    IN_inboundPlanOrderNo = arr2.toString()
                }

            }
            if(CN_cartonNo){
                arr3 = CN_cartonNo.split(/\n/);
                arr3.map(item=>{
                    if(item){
                        arr4.push(item)
                    }
                })
                if(arr4.length>0){
                    cartonNo = arr4.toString()
                }
            }

            params.warehouseId = warehouseId;
            params.cartonNo = cartonNo;
            params.sku = sku;
            params.search.IN_inboundPlanOrderNo = IN_inboundPlanOrderNo;

            delete params.search.warehouseId;
            delete params.search.CN_cartonNo;
            delete params.search.sku;
            delete params.search.CN_inboundPlanOrderNo;
            return this.handleParams(params)
        },
        handleOperates(params = "", type, batch) {
            // if (batch === true) {
            //     params = (params || this.checkedData.join(',')) + '';
            //     if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            // }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false,
                        alertbox:'alertbox',
                        managetype:'manage',
                    }
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "inboundBillmanageDetail",
                        params: { type: "query" },
                        query: { id: params,type:'manage' },
                    }).href, '_blank');
                    break;
                case 'edit':
                    window.open(this.$router.resolve({
                        name: "inboundBillmanageDetail",
                        params: { type: "edit" },
                        query: { id: params,type:'manage' },
                    }).href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.cancel', { defaultValue: '取消' }),
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpCancelInboundBill,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('fbb.inbound.cancel_reason', { defaultValue: '取消原因' })
                            }
                        ]
                    };
                    break;
                case "errorReprocess":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.error_process', { defaultValue: '异常重处理' }),
                        params: { id: params },
                        ajaxRequest: HttpReprocessError,
                    };
                    break;
                case "errorIgnore":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.error_ignore', { defaultValue: '忽略异常' }),
                        params: { id: params },
                        ajaxRequest: HttpIgnoreInboundError,
                    };
                    break;
                case "submit":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                        params: { id: params },
                        ajaxRequest: HttpSubmitInboundBill,
                    };
                    break;
                    case "addRemark":
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                            width: 'middle',
                            showDesc: false,
                            params: { id: params },
                            ajaxRequest: HttpRemarkInboundBill,
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    labelWidth: 'auto',
                                    span: 24,
                                    label: this.$t('global.common.notes', { defaultValue: "备注" })
                                }
                            ]
                        };
                        break;
                case "changewarehouse":
                    // this.getWareList(params)
                    this.operate = {
                        title: this.$t('fbb.inbound.change_warehouse', { defaultValue: '换仓' }),
                        show:true,
                        width:450,
                        component: "comWarehouse",
                        itemjson:params,
                        querytype:'query',
                        showFooter:false,
                    }
                    break;
                case 'export':
                    this.handleWebfs(HttpExportInboundBill, this.interceptRequest(JSON.parse(JSON.stringify(this.formData))), { executor: 'request', download: true });
                    break;
                case 'changeship':
                    this.operate = {
                        title: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                        show:true,
                        width:1200,
                        component: "compDelivergood",
                        orderid:params,
                        isEdit:true,
                        activeid:params,
                        changetype:'inbound',
                        showFooter:false
                    };
                    break;
                case 'seeyuyue':
                    this.operate = {
                        title: this.$t('fbb.inbound.view_appointment_form', { defaultValue: '查看预约单' }),
                        show:true,
                        width:1200,
                        component: "compAppointorder",
                        activeid:params,
                        showFooter:false
                    };
                    break;
                case "modifyDate":
                    this.operate = {
                        title: this.$t('fbb.inbound.modify_date', { defaultValue: '修改日期' }),
                        show:true,
                        width:600,
                        component: "modifyDate",
                        inboundPlanOrderId:params,
                        querytype:'query',
                        showFooter:false,
                        alertbox:'alertbox'
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id,estimateArriveTime,expectArriveDate, inboundPlanOrderStatus, sourceSystem, inboundPlanOrderNo, organizationId,errorStatus } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                show: (inboundPlanOrderStatus == 6 || inboundPlanOrderStatus == 0) && this.perUpdate,
                params: id,
                operate: 'submit'
            },
            {
                label: this.$t('fbb.inbound.change_warehouse', { defaultValue: '换仓' }),
                show: (inboundPlanOrderStatus == 20 || inboundPlanOrderStatus == 8 || inboundPlanOrderStatus == 10) && this.perUpdate,
                params: {id,inboundPlanOrderNo,organizationId,inboundPlanOrderStatus,estimateArriveTime,expectArriveDate},
                operate: 'changewarehouse'
            },
            {
                label: this.$t('global.common.cancel', { defaultValue: '取消' }),
                show: inboundPlanOrderStatus != 25 && inboundPlanOrderStatus != 70 && inboundPlanOrderStatus != 100 && sourceSystem == 0 && this.perUpdate,
                params: id,
                operate: 'cancel'
            },{
                label: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                show: inboundPlanOrderStatus == 20,
                params: id,
                operate: 'changeship'
            },{
                label: this.$t('fbb.inbound.check_appointment', { defaultValue: '查看预约情况' }),
                show: inboundPlanOrderStatus == 20 || inboundPlanOrderStatus == 25 || inboundPlanOrderStatus == 70,
                params: inboundPlanOrderNo,
                operate: 'seeyuyue'
            }, {
                label: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                show: true,
                params: id,
                operate: 'addRemark'
            },
                {
                    label: this.$t('global.common.reprocess', { defaultValue: '重处理' }),
                    show: errorStatus != 99999,
                    params: id,
                    operate: 'errorReprocess'
                },
                {
                    label: this.$t('global.common.ignoreError', { defaultValue: '忽略异常' }),
                    show: errorStatus != 99999,
                    params: id,
                    operate: 'errorIgnore'
                },{
                    label: this.$t('fbb.inbound.modify_date', { defaultValue: '修改日期' }),
                    show: inboundPlanOrderStatus==8 || inboundPlanOrderStatus==10, //待装箱 8;待发货 10
                    params: id,
                    operate: 'modifyDate'
                },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList','getBillcusAndFbaWareList', 'getUserManageWarehouseList','getCusproductList', 'getBillcusWareList']),
        TabsData() {
            // return [{
            //             //     label: '全部',
            //             //     value: null,
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'all',
            //             // }, {
            //             //     label: '待审核',
            //             //     value: '5',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'submit',
            //             // }, {
            //             //     label: '审批拒回',
            //             //     value: '6',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'reject',
            //             // }, {
            //             //     label: '待装箱',
            //             //     value: '8',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'approved',
            //             // }, {
            //             //     label: '待发货',
            //             //     value: '10',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'unshipped',
            //             // }, {
            //             //     label: this.$t('fbb.inbound.stock_pending', { defaultValue: '待入库' }),
            //             //     value: '20',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'shipped',
            //             // },{
            //             //     label: this.$t('fbb.inbound.inthe_library', { defaultValue: '入库中' }),
            //             //     value: '25',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'inthe_library',
            //             // },{
            //             //     label: this.$t('global.common.finished', { defaultValue: '已完成' }),
            //             //     value: '70',
            //             //     key: 'EQ_inboundPlanOrderStatus',
            //             //     spanKey: 'finished',
            //             // },
            //             // {
            //             //     label: this.$t('fbb.common.error_order', { defaultValue: '异常单' }),
            //             //     value: 99999,
            //             //     key: 'NE_errorStatus',
            //             //     spanKey: 'error_order',
            //             // },]
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: "全部" }),
                    key: 'quanbu',
                    val: 0,
                    spanKey: 'allQty',
                },
                {
                    name: this.$t('fbb.inbound.check_pending', { defaultValue: "待审核" }),
                    key: 'shenhe',
                    val: 0,
                    spanKey: 'unApprovedQty',
                }, {
                    name: this.$t('fbb.inbound.approval_back', { defaultValue: "审批拒回" }),
                    key: "juhui",
                    val: 0,
                    spanKey: 'refusedQty',
                },{
                    name: this.$t('fbb.inbound.for_packing', { defaultValue: "待装箱" }),
                    key: "unpacked",
                    val: 0,
                    spanKey: 'unPackedQty',
                }, {
                    name: this.$t('fbb.inbound.send_goods', { defaultValue: "待发货" }),
                    key: "unship",
                    val: 0,
                    spanKey: 'unShippedQty',
                }, {
                    name: this.$t('fbb.inbound.stock_pending', { defaultValue: "待入库" }),
                    key: "shipped",
                    val: 0,
                    spanKey: 'unReceivedQty',
                },
                {
                    name: this.$t('fbb.inbound.inthe_library', { defaultValue: '入库中' }),
                    key: 'inthe_library',
                    val: 0,
                    spanKey: 'inboundQty',
                },
                {
                    name: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    key: "finished",
                    val: 0,
                    spanKey: 'completedQty',
                },
                {
                    name: this.$t('fbb.order.error_order', { defaultValue: "异常单" }),
                    key: "error_order",
                    val: 0,
                    spanKey: 'errorQty',
                },
            ]
        },
        ToolsData() {
            return [{
                name: this.$t('global.common.export', { defaultValue: '导出' }),
                operate: "export",
            }]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' }),
                    key: 'CN_inboundPlanOrderNo',
                    show: true,
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder:this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1",
                    },
                    style: 'width: 150px'
                },
                {
                    label: this.$t('fbb.inbound.container_no', { defaultValue: "集装箱号" }),
                    key: 'CN_cartonNo',
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder:this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1"
                    },
                    show: true,
                    style: 'width: 150px'
                },
                // {
                //     label: "仓库",
                //     key: 'warehouseId',
                //     show: true,
                //     tag: 'vSelect',
                //     options: this.getBillcusWareList,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    tag: 'vSelect',
                    show: true,
                    key: 'IN_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: 'width: 150px'
                },
                {
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: "客户组织" }),
                    key: 'IN_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: 'width: 150px',
                    show: true,
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'IN_inboundPlanOrderStatus',
                    tag: 'vSelect',
                    options: this.getBillStatus,
                    props: {
                        filterable: true,
                        multiple:true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.errorcode', { defaultValue: "异常类型" }),
                    tag: 'vSelect',
                    key: 'EQ_errorStatus',
                    options: this.getAbnormalType,
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    key: 'EQ_inventoryType',
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: "Shipment ID",
                    key: 'EQ_shipmentId',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: "Reference ID",
                    key: 'EQ_referenceId',
                    tag: 'vInput',
                    style: widthStyle
                },

                {
                    label: this.$t('fbb.inbound.purchase_order_no', { defaultValue: "采购单号" }),
                    key: 'CN_poNos',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.batch_number_query', { defaultValue: "批次号查询" }),
                    key: 'CN_batchNumber',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.logistics_singleno', { defaultValue: "物流单号" }),
                    key: 'EQ_tmsNo',
                    tag: 'vInput',
                    style: widthStyle
                },

                {
                    label: "SKU",
                    key: 'sku',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.transfer.istakepictures', { defaultValue: "是否拍照" }),
                    tag: "vSelect",
                    key: "EQ_hasPicture",
                    options: [
                        {
                            label: this.$t('tms.ship.correct', { defaultValue: "是" }),
                            value: 1
                        },
                        {
                            label: this.$t('tms.ship.deny', { defaultValue: "否" }),
                            value: 0
                        }
                    ],
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.exped_warehousedate', { defaultValue: '预计入库日期' }),
                    key: 'BT_estimateArriveTime',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.date_firstreceipt', { defaultValue: '首次接收日期' }),
                    key: 'BT_firstReceptionDate',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.expect_arrivaldate', { defaultValue: '期望到货日期' }),
                    key: 'BT_expectArriveDate',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'BT_updatedAt',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.expect_deliverydate', { defaultValue: '预计发货日期' }),
                    key: 'BT_predictionShipDate',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('fbb.inbound.client_organization', { defaultValue: "客户组织" }),
                    key: 'orgName'
                    // render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId)
                }, {
                    title: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' })+'/'+this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    render: (h, { row }) => {
                        return <div>
                            {/* <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}>{row.inboundPlanOrderNo || '--'}</a> */}
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.inboundPlanOrderNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <br />
                            {row.sourceNo || '--'}
                            <br />
                            <div><span style="color:red;">{this.findRenderLabel(this.getAbnormalType, row.errorStatus)}</span></div>
                        </div>
                    }
                }, {
                    title: this.$t('erp.channelbase.area', { defaultValue: "区域" }) + "/" + this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode',
                    render: (h, { row }) => {
                        if (row.areaId) {
                            let areaName = this.areaList.filter(item => {
                                return item.value == row.areaId;
                            })[0].label;
                            return <div>{areaName}{row.orgWarehouseCode ? "/" + row.orgWarehouseCode : ""}</div>
                        }
                        return <div>
                            <div>{row.orgWarehouseCode || "--"}</div>
                        </div>
                    }
                }, {
                    title: this.$t('global.common.line', { defaultValue: '项目' }),
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.lineName || '--'}</div>
                            <div>{this.findRenderLabel(this.getInventoryType, row.inventoryType)}</div>
                        </div>
                    }
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'inboundPlanOrderStatus',
                    render: (h, { row }) => {
                        const status = row.inboundPlanOrderStatus;
                        const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{status ? label : this.$t('fbb.inbound.draft', { defaultValue: '草稿' })}</vButton>
                    }
                }, {
                    title: 'Shipment ID/Reference ID',
                    key: 'totalCost',
                    render: (h, { row }) => {
                        return <div>
                            {row.shipmentId || '--'}
                            <br />
                            {row.referenceId || '--'}
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.exped_warehousedate', { defaultValue: '预计入库日期' })+'/'+this.$t('fbb.inbound.date_firstreceipt', { defaultValue: '首次接收日期' }),
                    key: 'currency',
                    render: (h, { row }) => {
                        return <div>
                            {row.estimateArriveTime || '--'}
                            <br />
                            {`${row.firstReceptionDate || '--'}`.slice(0, 10)}
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    sortable:true,
                }];
        },
    },
};




